import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Thu Aug 29 2018
 * @author LZe
 */
import * as React from 'react';
import Input from '../../../../inputs/Input';
import FormGroup from '../../../../forms/FormGroup/FormGroup';
import Label from '../../../../typography/Label';
import FilterWrapper from './FilterWrapper';
import translate from '../../../../i18n/translate';
import Filter from './Filter';

var TextFilter =
/*#__PURE__*/
function (_Filter) {
  _inherits(TextFilter, _Filter);

  function TextFilter() {
    var _this;

    _classCallCheck(this, TextFilter);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TextFilter).apply(this, arguments));
    _this.state = {
      value: ''
    };

    _this.onChange = function (event) {
      _this.setState({
        value: event.target.value
      }, _this.props.filterChangedCallback);
    };
    /**
     * This function determines wheter column's filter is active
     */


    _this.isFilterActive = function () {
      return _this.state.value != null && _this.state.value !== '';
    };
    /**
     * Compares the searched value if its included in the row value
     */


    _this.doesFilterPass = function (params) {
      return _this.props.valueGetter(params.node) ? _this.props.valueGetter(params.node).toString().toLowerCase().includes(_this.state.value.toLowerCase()) : false;
    };
    /**
     * Resets input values and clears filter
     */


    _this.onClear = function () {
      _this.setState({
        value: ''
      }, _this.closePopup);
    };

    return _this;
  }
  /**
   * This function is for getColumnState() output and similar
   */


  _createClass(TextFilter, [{
    key: "getModel",
    value: function getModel() {
      return {
        value: this.state.value
      };
    }
    /**
     * This function set filter state from setColumnState() input and similar
     * @param model data input
     */

  }, {
    key: "setModel",
    value: function setModel(model) {
      this.setState({
        value: model ? model.value : ''
      }, this.props.filterChangedCallback);
    }
    /**
     * Updates filter if value in floating filter changes
     * @param model object with filter state
     */

  }, {
    key: "onFloatingFilterChanged",
    value: function onFloatingFilterChanged(model) {
      if (!model) {
        this.setState({
          value: ''
        }, this.props.filterChangedCallback);
      } else {
        this.setState({
          value: model.value
        }, this.props.filterChangedCallback);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(FilterWrapper, {
        onApply: this.onApply,
        onClear: this.onClear
      }, React.createElement(FormGroup, {
        noLabel: false
      }, React.createElement(Label, null, "".concat(translate('Search'), ":")), React.createElement(Input, {
        value: this.state.value,
        onChange: this.onChange,
        placeholder: "".concat(translate('Search'), "..."),
        tiny: true
      })));
    }
  }]);

  return TextFilter;
}(Filter);

export { TextFilter as default };